import { useLocation } from 'react-router-dom';
import '@styles/overallstats.css'; // Import the CSS file

const OverallStats = () => {
  const { state } = useLocation();
  const stats = state?.stats || {};

  return (
    <div className="stats-page calendar-page">
      <h2 className="stats-title">Overall Statistics</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Weight Lifted</h3>
          <p>{stats.totalWeight}kg</p>
        </div>
        <div className="stat-card">
          <h3>Total Reps</h3>
          <p>{stats.totalReps}</p>
        </div>
        <div className="stat-card">
          <h3>Total Sets</h3>
          <p>{stats.totalSets}</p>
        </div>
        <div className="stat-card">
          <h3>Total Volume</h3>
          <p>{stats.totalVolume}kg</p>
        </div>
        <div className="stat-card">
          <h3>Average Weight/Set</h3>
          <p>{stats.avgWeightPerSet?.toFixed(1)}kg</p>
        </div>
        <div className="stat-card">
          <h3>Average Reps/Set</h3>
          <p>{stats.avgRepsPerSet?.toFixed(1)}</p>
        </div>
      </div>
    </div>
  );
};

export default OverallStats;